export default "__VITE_PUBLIC_ASSET__33074bbd__"